import {
  SET_CATEGORY,
  //
  SET_APP_FILTER,
  SET_UI_FILTER,
  APPLY_UI_FILTER,
  RESET_UI_FILTER,
  RESET_FILTER,
} from '../../constants/filter';

export const setCategory = (payload) => ({
  type: SET_CATEGORY,
  payload,
});

export const applyUIFilter = () => ({ type: APPLY_UI_FILTER });
export const resetUIFilter = () => ({ type: RESET_UI_FILTER });

/**
 * For saga middleware
 */
export const resetFilter = () => ({
  type: RESET_FILTER,
});
export const setAppFilter = (payload) => ({
  type: SET_APP_FILTER,
  payload,
});
export const setUIFilter = (payload) => ({ type: SET_UI_FILTER, payload });
